import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 11.25h7.5A1.76 1.76 0 0 0 17.5 9.5V2A1.76 1.76 0 0 0 15.75.25h-7.5A1.76 1.76 0 0 0 6.5 2v7.5a1.76 1.76 0 0 0 1.75 1.75M8.75 5V4a1.5 1.5 0 0 1 1.5-1.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0m.5 7.75h-7.5A1.76 1.76 0 0 0 0 14.5V22a1.76 1.76 0 0 0 1.75 1.75h7.5A1.76 1.76 0 0 0 11 22v-7.5a1.76 1.76 0 0 0-1.75-1.75m-4 2.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a1.5 1.5 0 0 1 1.5-1.5h1a.5.5 0 0 1 .5.5m17-2.75h-7.5A1.76 1.76 0 0 0 13 14.5V22a1.76 1.76 0 0 0 1.75 1.75h7.5A1.76 1.76 0 0 0 24 22v-7.5a1.76 1.76 0 0 0-1.75-1.75m-4 2.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a1.5 1.5 0 0 1 1.5-1.5h1a.5.5 0 0 1 .5.5"
    }, null, -1)
  ]));
}
const programmingModuleThree = { render };
export {
  programmingModuleThree as default,
  render
};
//# sourceMappingURL=programming-module-three.svg.js.map
